import types from '../actionTypes';

export const setFilter = payload => ({
    type: types.SET_FILTER,
    payload,
});
